import * as React from 'react'
import NoPageAccess from '../NoPageAccess'

type PrivateRouteProps = {
  element: React.ReactNode
  isSignedIn: boolean
}

const PrivateRoute = ({ element, isSignedIn }: PrivateRouteProps) => {
  if (isSignedIn) return <>{element}</>
  return <NoPageAccess />
}

export default PrivateRoute
